import { Component, OnInit, OnDestroy,  ViewChild, ElementRef,  } from '@angular/core';
import { VideoListService } from '../_service/video/video-list.service';
import { CategoryService } from '../_service/category/category.service';
import { Subscription, fromEvent } from 'rxjs';
import {  ScreenSize } from '../_service/screen-size.service';
import { RankedVideosService } from '../_service/video/ranked-videos.services';
import { environment } from '../../environments/environment';
import { UserService } from '../_service/user/user.service';
import { Utility } from '../_service/utility';
import { SeoService } from '../seoservice/seoservice';
import { ActivatedRoute } from '@angular/router';
import { DiscoveryService } from 'app/discovery/discovery.service';

@Component({
  selector: 'app-index',
  templateUrl: './index.component.html',
  styleUrls: ['./index.component.scss'],
})

export class IndexComponent implements OnInit, OnDestroy {
//  isAdult = environment.cinema === 2;
//  isMonitorAvailable = !this._utility.isIphoneDevice();
  currentCategory: any = {};
  subscriptions: Subscription[] = [];
  guessYouLikeVideos;
  guessYouLikeTotal = 24;
  guessYouLikePageIndex = 0;
  guessYouLikePageSize = 7;
  contentLoading;

  public categories;
  screenType = ScreenSize;
  screenSize;
  //recentAdded;
  newscategories
  private user = null;
  fitems: Array<any> = [];

  hot = [];
  hotLength = 16;
  isHotLoading = false;
  shadowOpen = false;
  openType = '';
  detailData;

  recentlyWatchedVideos = [];

  userToken = null;

  //component: ComponentRef<DiscoveryInHomeComponent>;
  constructor(
    private _videoListService: VideoListService,
    private _titleService: SeoService,
    private _rankedVideosService: RankedVideosService,
    private _user: UserService,
    private route: ActivatedRoute,
    private _categoryService: CategoryService,
    private _utility: Utility,
    private _discoveryService: DiscoveryService,

  ) {

  }
  public list = [];
  private unsb = null;
  shouldLoad = true;
  lastuid = 0;
  ngOnInit() {
    this._titleService.setTitle('');
    this._titleService.setDescription();
   // this.getFlashBanner();
    this._rankedVideosService.updateRankedVideos();
    //this.userToken = this._storage.GetLocalSession();
    this.subscriptions.push(
      this._user.userState$.subscribe(p => {
        this.user = p;
        //this.userToken = this._storage.GetLocalSession();
        this.readState();
        if (this.user.id > 0 &&
          this.lastuid != this.user.id
        ) {
          this.getRecentlyWatchedVideos();
        }
        this.lastuid = this.user.id;
        //console.log(this.user)
        if (!this.user.id) {
          this.recentlyWatchedVideos = [
          ];
          this.isNoWatching = true;
        }
      }),
      //fromEvent(window,"scroll",{passive:true}).subscribe(animateDebounce(this.onWindowScroll.bind(this)).bind(this))

    );

    this.subscriptions.push(
      this._categoryService.getCategoryList()
        .subscribe(items => {
          this.categories = items.filter(p => !p.navOnly && !p.tagFilter);
          this.newscategories = items.filter(p => !p.navOnly && p.tagFilter && p.cid !== 'svideo');

        })
    );

    this.subscriptions.push(
      this._videoListService.getRecommendedVideoList()
        .subscribe(lists => {
          this.pendingList = { ...this.pendingList, ...lists };
          this.flowControl();
        })
    );

    if (environment.cinema == 1) {
      this._videoListService.getRecommendedVideoList("NEWS_ENDPOINT")
        .subscribe(lists => {
          this.pendingList = { ...this.pendingList, ...lists };
          this.flowControl();
        })

    };




    // if (environment.app) {
    //   this.route.fragment.subscribe(fragment => {
    //     if (!this.isInit) {
    //       //console.log("aa",frames)
    //       if (fragment && fragment.indexOf("navurl_") > -1) {
    //         this.shouldLoad = false;
    //         return false;
    //       }
    //       this.isInit = true;
    //     }

    //   })
    // }


  }
  isInit = false;
  pendingList = [];
  private readState() {

  }
  
  //disableHover = false;
  // timer = null;
  // onWindowScroll()
  // {
  //   clearTimeout(this.timer);
  //   this.disableHover = true;
  //   this.timer = setTimeout(()=>{
  //     this.disableHover = false;
  //   },200);

  // }
  triggerGetHot(event) {
    this.discoverLoaded = true;
    //this.getDiscoveryList();
  }
  listToLoad = [
    "filmList",
    "tvList",
    "varietyList",
    "animeList",
    "chineseList",
    "gamesList",
    "newsList",
    "yuleList",
    "lifeList",
    "musicList",
    "fashionList",
    "techList"
  ]
  timeout = null;
  /*
  ** 控制一下加载顺序, 如果内容为空，则之后加载
  */
  flowControl() {
    if (this.timeout) {
      clearTimeout(this.timeout);
    }
    this.timeout = setTimeout(() => {
      var toLoad = this.listToLoad.shift();
      if (toLoad == "discovery") {
      }
      else {
        if (!!this.pendingList[toLoad])
          this.list[toLoad] = this.pendingList[toLoad];
        else {
          this.listToLoad.push(toLoad);
        }
      }

      if (this.listToLoad.length > 0) {
        this.flowControl();
      }
    }, 200);
  }


  @ViewChild("place") viewElement: ElementRef;
  ngOnDestroy() {
    this.subscriptions.forEach(s => s.unsubscribe());
    if (this.unsb != null) this.unsb();
    if (this.timeout) {
      clearTimeout(this.timeout);
    }
    //this.appRef.detachView(this.component.hostView);
    //this.component.destroy();
  }

  ngAfterViewInit() {
    //let host = document.createElement("div");
    //const reforeNode = document.getElementById("topVideoNews");
    //host.appendChild((this.component.hostView as any).rootNodes[0]);
    // this.elementRef.nativeElement.appendChild(host);
    //this.insertAfter(host, reforeNode);
  }

  //   insertAfter(newElement, targetElement) {
  //     let parent = targetElement.parentNode;
  //     if (parent.lastChild === targetElement){
  //       parent.appendChild(newElement);
  //     } else {
  //       parent.insertBefore(newElement, targetElement);
  //     }
  // }

  // getRandomVideos() {
  //   const adultCid = '0,2,10';
  //   this.subscriptions.push(
  //     this._randomVideosService.randomVideosSource$.subscribe(r => {
  //       if (!r.find(c => c.cid === adultCid)) {
  //         this._randomVideosService.updateRandomVideos(adultCid);
  //       }
  //     })
  //   );
  // }



  // refreshGuessYouLikeVideos() {
  //   this.contentLoading = true;
  //   this.subscriptions.push(
  //     this._videoListService.getGuessYouLikeVideos('0,2,10').subscribe(r => {
  //       this.contentLoading = false;
  //       const start = (this.guessYouLikePageIndex % this.guessYouLikePageSize) * this.guessYouLikePageSize;
  //       this.guessYouLikeVideos = r.splice(start, start + this.guessYouLikePageSize);
  //       this.guessYouLikePageIndex += 1;
  //       if (this.guessYouLikePageIndex === 4) {
  //         this.guessYouLikePageIndex = 0;
  //       }
  //     })
  //   );
  // }

  getDiscoveryList() {
    // this.subscriptions.push(
    //   this._discoveryService.getHotAlbums(this.hotLength, false).subscribe(res => {
    //     this.hot = res;
    //   }),
    // );
  }

  changeHots() {
    if (this.isHotLoading) {
      return;
    }
    this.isHotLoading = true;

    this._discoveryService.getHotAlbums(this.hotLength, true).subscribe(res => {
      this.hot = res;
      setTimeout(() => {
        this.isHotLoading = false;
      }, 300);
    })
  }

  detailOpenHandler(e) {
    // console.log(e);
    if (e.infoType === 3 || e.infoType === 1 || e.infoType === 0) {
      this.detailData = e;
      this.shadowOpen = true;
      this.openType = 'detail';
    }
  }

  closeHandler(e) {
    this.close();
  }

  close() {
    this.shadowOpen = false;
    this.openType = '';
  }

  isNoWatching = false;
  getRecentlyWatchedVideos() {
    this._videoListService.getRecentlyWatchedVideos().subscribe(r => {
      // console.log(r);
      if (r.length > 0) {
        this.isNoWatching = false;
        this.recentlyWatchedVideos = r.map(p => {
          return {
            ...p,
            image: p.imgPath,
            key: p.lidKey,
            rating: p.pinfen,
            updates: p.todayNum,
            cidMapper: p.tags,
            recommended: p.isIndex,
            vipResource: p.vipResource ? p.vipResource : '',
          }
        });
      } else {
        this.recentlyWatchedVideos = [
        ];
        this.isNoWatching = true;
      }
    });
  }
  discoverLoaded = false;
}
